import {
  agentActivityReport,
  dashboardReport,
  funnelTags,
  responsivenessReport,
} from '@/constants/endpoints';

import { APIClient } from '@/lib/ApiClient';

const apiClient = new APIClient();

export function fetchAgentActivityData(startDate, endDate, contactOption) {
  return apiClient.get(
    agentActivityReport,
    {
      from: startDate,
      to: endDate,
      ...(contactOption ? { contact: contactOption } : {}),
    },
    true
  );
}

export function fetchDashboardData(type, value) {
  return apiClient.get(
    dashboardReport,
    {
      type, //:'pre-defined',
      value, //: 'last-week',
    },
    true
  );
}

export function fetchFunnelTags() {
  return apiClient.get(funnelTags, {}, true);
}

export function updateFunnelTags(tagIds) {
  return apiClient.overwrite(
    funnelTags,
    {
      tag_ids: tagIds,
    },
    true
  );
}

export function fetchResponsivenessData(type, value, agentId) {
  return apiClient.create(
    responsivenessReport,
    {
      type, //:'pre-defined',
      value, //: 'last-week',
      ...(agentId ? { agent: agentId } : {}),
    },
    true
  );
}
